import React from 'react';
import Swiper from 'swiper';
import PropTypes from 'prop-types';
import UpArrowSvg from '../svg/up_arrow';
import DownArrowSvg from '../svg/down_arrow';

import './carousel.scss';

export default class Carousel extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      slideNavSize: 0,
      activeSlide: 0
    }
  }

  updateNav = (index) => {
    this.setState({
      activeSlide: index
    })
  }

  componentWillMount() {
    this.swiper = null;
  }

  componentDidMount() {
    const { slideData } = this.props;
    const { updateNav, carousel, handleNext, handlePrev } = this;
    const navSize =  (1 / slideData.length * 100) + '%';

    this.setState({
      slideNavSize: navSize
    })

    this.swiper = new Swiper(carousel, {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      grabCursor: true,
      longSwipesMs: 100,
      direction: 'horizontal',
      mousewheel: false,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      longSwipesRatio: 0.1,
      pagination: {
        el: '.carousel-progress--pagination',
        type: 'bullets',
        clickable: true,
      },
      on: {
        slideChange: function () {
          updateNav(this.realIndex)
        }
      },
    });

    window.addEventListener('resize', this.swiper.updateSize());
  }

  componentWillUnmount() {
    window.removeEventListener('resize');
  }

  handleNext = () => {
    if (!this.swiper) return
    this.swiper.slideNext();
  }

  handlePrev = () => {
    if (!this.swiper) return
    this.swiper.slidePrev();
  }

  render() {
    const { slideNavSize, activeSlide } = this.state;
    const { slideData } = this.props;

    return (
      <div className="Carousel">

        <div className="swiper-buttons-container">

          <div className="carousel-buttons">
            <span onClick={this.handlePrev.bind(this)} className="up-arrow"><UpArrowSvg className="up-arrow-icon" /></span><br />
            <span className="slide-counts">{this.state.activeSlide+1} / {slideData.length}</span><br />
            <span onClick={this.handleNext.bind(this)} className="down-arrow"><DownArrowSvg className="down-arrow-icon" /></span>
          </div>
        
          <div className="swiper-container" ref={el => this.carousel = el}>
            <div className="Carousel__slides swiper-wrapper">
              {slideData.map((slide, i) => (
                <div key={i} className="swiper-slide">
                  <figure className="slide__figure" style={{ backgroundImage: 'url(' + slide.src + ')' }}>
                  </figure>
                </div>
              ))}
            </div>

            <div className="carousel-progress">
              <div className="carousel-progress--pagination"></div>
            </div>
          </div>
        </div>

        <div className="carousel-captions">
          {slideData.map((slide, i) => {
            const active = i === activeSlide ? 'caption--active' : '';
            return (
              <div className={`caption ${active}`} key={i}>
                <div className="caption-title">{slide.title}</div>
                <p>{slide.caption}</p>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

Carousel.propTypes = {
  slideData: PropTypes.array,
  onEnter: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/carousel/carousel.js